module.exports = __webpack_public_path__ + "img/orb_hunter.3982875b.png";